import { Speaker, SpeakerMapping } from '../calls.service'
import { formatSpeaker } from '../speaker.pipe'

type Segment = {
  left: number
  width: number
  startTimeSeconds: number
  duration: number
  originalTag: string
}

export type SpeakerSlot = {
  speaker: Speaker
  segments: Segment[]
}

export function roundToTwoDecimals(value: number): number {
  return Math.round(value * 100) / 100
}

export function generateXRaySpeakers(speakers: Speaker[], duration: number, speakerMapping: SpeakerMapping): SpeakerSlot[] {
  const filteredSpeakers = speakers.filter((speaker) => formatSpeaker(speaker, speakerMapping) !== '')
  const pairedSpeakers = filteredSpeakers.map((speaker, index) => {
    return [speaker, filteredSpeakers[index + 1] ?? null]
  })
  return Object.values(
    pairedSpeakers.reduce(
      (acc, [speaker, nextSpeaker]) => {
        const currentSpeakerDuration = nextSpeaker !== null ? nextSpeaker.startTimeSeconds - speaker.startTimeSeconds : duration - speaker.startTimeSeconds
        const item = {
          left: roundToTwoDecimals((speaker.startTimeSeconds / duration) * 100),
          width: roundToTwoDecimals((currentSpeakerDuration / duration) * 100),
          duration: currentSpeakerDuration,
          startTimeSeconds: speaker.startTimeSeconds,
          originalTag: speaker.originalTag ?? speaker.speakerTag,
        }
        if (acc.hasOwnProperty(speaker.speakerTag)) {
          acc[speaker.speakerTag].segments.push(item)
        } else {
          acc[speaker.speakerTag] = { speaker: speaker, segments: [item] }
        }
        return acc
      },
      {} as { [speakerTag: string]: SpeakerSlot }
    )
  )
}
